import Vue from 'vue';

function inboxForm() {
    return {
        inbox: [],
        cat_category_id: null,
        cat_procedure_id: null,
    }
}

function manageTemplates() {
    return {
        form: {},
        sipac_request_id: null,
        cat_procedure_id: null,
        templates: [],
        html: null,
        isEditing: false,
        isPaper: false,
        isGenerate: false
    }
}

function filters() {
    return {
        arrayFilters: null,
        countRequests: null,
    }
}

const state = {
    inboxForm: inboxForm(),
    filters: filters(),
    manageTemplates: manageTemplates()
};

const mutations = {

    addTemplates(state, data) {
        state.manageTemplates = data;
    },


};

const actions = {

    fetchSigle({state, commit, dispatch}, {crypt_id} = {}) {

        dispatch('loading/spinner', {msg: 'Cargando Información...', status: true}, {root: true});

        return axios.get(`/api/get-documents/${crypt_id}`)
            .then((res) => {
                dispatch('loading/spinner', {}, {root: true});

                const parsedResponse = res.data;
                if (parsedResponse) {

                    return parsedResponse;
                } else {
                    return Promise.reject(parsedResponse);
                }

            })
            .catch((err) => {
                console.log(err);
                dispatch('loading/spinner', {}, {root: true});
                let msg = 'No se pudo completar la acción';
                if (err.response &&
                    err.response.data &&
                    err.response.data.message
                    && err.response.status == 400) {
                    msg = err.response.data.message;
                }
                dispatch('notifications/error', {msg: msg}, {root: true});
                return Promise.reject(err);

            });
    },

    addProcedureData({commit}, data) {
        commit('addProcedureData', data);
    },

    addTemplates({commit}, data) {
        commit('addTemplates', data);
    },

};

const getters = {
    inboxForm: state => state.inboxForm,
    filters: state => state.filters,
    manageTemplates: state => state.manageTemplates
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};

